import { Alert, Box, Button, Image, Stack, Text, Title } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useAuth } from 'hooks/useAuth';
import { useMsalAuth } from 'hooks/useMsalAuth';
import { loginRequest } from 'configs/msalConfig';
import React from 'react';
import { showErrorNotification, showSuccessNotification } from 'utils/notification';

type RightSectionProps = {
  redirectTo?: string;
};

const RightSection = ({ redirectTo = '/' }: RightSectionProps) => {
  const { loginPopup, getAccessToken } = useMsalAuth();
  const { login, isLoading, isError, errorMessage } = useAuth();

  const handleLogin = async () => {
    try {
      const loginResult = await loginPopup();
      const { account } = loginResult;

      if (!account?.username || !account.homeAccountId) {
        throw new Error('Microsoft account information was not found.');
      }

      const accessToken = loginResult.accessToken || (await getAccessToken(loginRequest.scopes));

      const { user } = await login({
        userName: account.username,
        accessToken,
        msalAccountId: account.homeAccountId,
        redirectTo
      });

      showSuccessNotification({
        title: 'Login Successful',
        message: `You have successfully logged in with account ${user.adminEmail}.`
      });
    } catch (error) {
      showErrorNotification({
        title: 'Failed Login with Microsoft Account',
        message: `Failed when login, please try again later. Error: ${String(error)}`
      });
    }
  };

  return (
    <Stack justify='center' align='center' h={'100%'}>
      <Box p='xl' w={'100%'} maw={'40rem'}>
        <Stack gap={16} h={'100%'} justify='center'>
          <Title order={2}>Log In to DACUM</Title>
          <Button
            onClick={handleLogin}
            leftSection={<Image src='/logo/logos_microsoft-icon.svg' h={20} w={20} />}
            variant='outline'
            loading={isLoading}
            disabled={isLoading}
          >
            Log In with Microsoft
          </Button>
          {isError && (
            <Alert color='red' title='Failed to login' icon={<IconExclamationCircle />}>
              <Text fw={'semibold'} fz={14}>
                {errorMessage}
              </Text>
            </Alert>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};

export default RightSection;
